import type { GuestServer } from "@adobe/uix-guest";

import type { ExtensionApi, EventPayload } from "./types";

export function handleTenantChange(
  guestConnection: GuestServer<ExtensionApi>,
  tenant: EventPayload["tenant"]
): void {
  console.log("Handle tenant change ", guestConnection, tenant);
  const eventPayload: EventPayload = {
    tenant,
    adobeUserToken: guestConnection.sharedContext.get("token") as string,
  };

  // Custom event our UE client script is listing to
  guestConnection.host.remoteApp.triggerEvent(
    "aue:onegraph-env",
    "body",
    eventPayload
  );
}
